export const EXCLUDED_FIELD_SETTING_ID = 56;

export interface YearClosure {
  lastClosedYear: number;
  openYear: number;
  unRealizedDutyLinesOpenYear: number;
}

export interface YearClosureTableData {
  year: number;
  isOpenedStatus: boolean;
  unrealizedDuties: number;
}

export interface SettingRes {
  groupId: number;
  value: 'true' | 'false';
  key: string;
  settingId: number;
}

export interface YearEndProcedureSettingsRes {
  settings: SettingRes[];
  groupName: string;
  groupId: number;
  active: boolean;
  valid: boolean;
}

export interface SettingReq {
  groupId: number;
  value: boolean;
  key: string;
  settingId: number;
}

export interface YearEndProcedureSettingsReq
  extends Omit<YearEndProcedureSettingsRes, 'settings'> {
  settings: SettingReq[];
}

export interface YearClosureProgressData {
  hasFinished: boolean;
  dutyLinesTotal: number;
  dutyLinesProgress: number;
  dutyLinesErrors: number;
  errorDetails: ErrorDetail[];
}

export interface ErrorDetail {
  key: string;
  employee: Employee;
  id: string;
}

export interface Employee {
  nameCompound: string;
  nr: number;
}
